module.exports = __webpack_public_path__ + "img/detection_error.888ed6f3.png";